import * as type from 'constants/action_types'
import { RESET_SUPPLIER_DATABASE } from 'constants/action_types'
import { DEFAULT_SUPPLIER_DB_SEARCH_FILTERS } from 'constants/filters'
import { buildSupplierId } from 'helpers/supplier'

export const initialState = {
  backButton: {
    linkText: null,
    path: null
  },
  searchType: 'Product',
  searchTerm: '',
  activeSupplier: {},
  filters: DEFAULT_SUPPLIER_DB_SEARCH_FILTERS,
  searchResults: null,
  totalSearchResults: 0,
  supplierSearch: {
    isLoading: false,
    completed: false
  },
  fetchSupplier: {
    isLoading: false
  },
  shipmentInfo: {
    pageSize: 10
  },
  supplierRegistry: {},
  saveSuppliers: {},
  companyLegalName: '',
  performCompanySearch: true
}

function supplier(state = initialState, action) {
  switch (action.type) {
    case type.UPDATE_SUPPLIER_BACK_BUTTON: {
      const newBackButtonState = action.payload
        ? { ...action.payload, show: true }
        : initialState.backButton
      return {
        ...state,
        backButton: newBackButtonState
      }
    }
    case type.PENDING_SUPPLIER_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: true
        }
      }
    case type.COMPLETED_SUPPLIER_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: true
        }
      }
    case type.RESET_SUPPLIER_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: false
        }
      }
    case type.SET_SUPPLIER_DATA: {
      return {
        ...state,
        [action.payload.prop]: action.payload.value
      }
    }
    case type.SET_SUPPLIER_MULTIPLE_DATA: {
      return {
        ...state,
        ...action.payload
      }
    }
    case type.UPDATE_SEARCH_RESULTS_SUPPLIER_DATA: {
      return {
        ...state,
        searchResults: state.searchResults.map(supplier => {
          if (supplier.supplier_id === action.payload.id) {
            return { ...supplier, ...action.payload.data }
          }
          return supplier
        })
      }
    }
    case type.SET_SUPPLIER_FILTER_DATA: {
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.name]: {
            ...state.filters[action.payload.name],
            [action.payload.property]: action.payload.value
          }
        }
      }
    }
    case type.RESET_SUPPLIER_DATA: {
      return {
        ...state,
        [action.payload]: initialState[action.payload]
      }
    }
    case type.SET_SUPPLIER_SHIPMENT_DATA: {
      return {
        ...state,
        shipmentInfo: {
          ...state.shipmentInfo,
          [action.payload.name]: {
            ...state.shipmentInfo[action.payload.name],
            [action.payload.property]: action.payload.value
          }
        }
      }
    }
    case type.SET_SHIPMENT_INFO_FILTER: {
      const { name, filter, property, value } = action.payload
      const supplierShipmentInfo = state.shipmentInfo[name]
      return {
        ...state,
        shipmentInfo: {
          ...state.shipmentInfo,
          [name]: {
            ...supplierShipmentInfo,
            filters: {
              ...supplierShipmentInfo.filters,
              [filter]: {
                ...supplierShipmentInfo.filters[filter],
                [property]: value
              }
            }
          }
        }
      }
    }
    case type.UPDATE_SUPPLIERS_REGISTRY: {
      return {
        ...state,
        supplierRegistry: {
          ...state.supplierRegistry,
          [buildSupplierId(action.payload)]: action.payload
        }
      }
    }
    case type.PENDING_SAVE_SUPPLIERS_ACTION:
      return {
        ...state,
        saveSuppliers: {
          ...state.saveSuppliers,
          [action.payload]: {
            isLoading: true,
            completed: false
          }
        }
      }
    case type.COMPLETED_SAVE_SUPPLIERS_ACTION:
      return {
        ...state,
        saveSuppliers: {
          ...state.saveSuppliers,
          [action.payload]: {
            isLoading: false,
            completed: true
          }
        }
      }
    case type.RESET_SAVE_SUPPLIERS_ACTION:
      return {
        ...state,
        saveSuppliers: {
          ...state.saveSuppliers,
          [action.payload]: {
            isLoading: false,
            completed: false
          }
        }
      }
    case RESET_SUPPLIER_DATABASE:
      return {
        ...initialState
      }
    default:
      return state
  }
}

export default supplier
